import { HelpCircleFillIcon, Text, Tooltip } from '@thefarmersfront/kitchen';

import { DELIVERY_AGENCY_TOOLTIP_MESSAGE } from '~/constants';

import styles from './DeliveryAgencyOutboundUnitGuide.module.scss';

const DeliveryAgencyOutboundUnitGuide = () => {
  return (
    <div className={styles['guide']}>
      <Text size="medium" color="tertiary">
        배송예정일과 배송지가 같은 주문은 하나로 묶어서 포장할 수 있어요.
      </Text>
      <Tooltip description={DELIVERY_AGENCY_TOOLTIP_MESSAGE.OUTBOUND_UNIT_CONDITION} maxWidth="348px">
        <HelpCircleFillIcon size={16} color="gray400" />
      </Tooltip>
    </div>
  );
};

export default DeliveryAgencyOutboundUnitGuide;
